import Icon from '../components/Icon.vue'

Icon.register({
  grin: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM328 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM248 432c60.6 0 134.5-38.3 143.8-93.3 1.9-11.8-9.4-21.6-20.7-17.9-30.2 9.7-75.1 15.2-123.1 15.2s-92.9-5.5-123.1-15.2c-11.4-3.7-22.7 6.1-20.7 17.9 9.3 55 83.2 93.3 143.8 93.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin.js
// module id = 1411
// module chunks = 0